import { useEffect, useState } from 'react';

const NavbarProjects = ({ activeTab, handleActiveTab, userDetails }) => {
  const [navList, setNavList] = useState('');

  const listsMap = userDetails.map((el, i) => {
    const checker = el.title || el.role;

    return i < 7 ? (
      <li
        key={el._id}
        className={
          activeTab === el.title || activeTab === el.role
            ? 'screen-navbar__lists-item source active'
            : 'screen-navbar__lists-item source'
        }
        onClick={() => handleActiveTab(checker)}
      >
        {checker !== el.title ? checker : checker.slice(0, 8)}
      </li>
    ) : null;
  });

  useEffect(() => {
    setNavList(listsMap);
  }, [activeTab]);

  return (
    <div className='screen-navbar'>
      <ul className='screen-navbar__lists'>{navList}</ul>
    </div>
  );
};

export default NavbarProjects;
